import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex w-full touch-none select-none items-center",
      className
    )}
    {...props}>
    <SliderPrimitive.Track className="relative h-1 w-full grow overflow-hidden bg-muted">
      <SliderPrimitive.Range className="absolute h-full bg-crimson" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb className="block h-3 w-3 border border-crimson/50 bg-crimson shadow transition-all duration-200 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-crimson disabled:pointer-events-none disabled:opacity-50 hover:scale-125 hover:shadow-neon cursor-grab active:cursor-grabbing" />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
